export default "__VITE_ASSET__991d399c__"